<p class="invoice-card-title">
    Invoice Payments
</p>

<div class="payments-table">
<p-table
    #dt
    [columns]=""
    [autoLayout]="true"
    [value]="_reportService.selectedInvoiceDetails?.tenders"
    responsiveLayout="scroll"
    showLoader="true"
    rowHover="true"
    [customSort]="true"
    [style]="{'min-width':'100%'}"
>
    <ng-template pTemplate="header">
        <tr>
            <th>Date</th>
            <th style="text-align: right">Amount</th>
            <th style="text-align: right">Other Charges</th>
            <th style="text-align: right" *ngIf="!_reportService.selectedInvoiceDetails?.isOnlineOrder">Tip</th>
            <th style="text-align: right">Balance</th>
            <th>Method</th>
            <th>Remarks</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr>
            <td>{{ item.date |date: 'short' }}</td>
            <td style="text-align: right">{{ item.amount | currency | currencySpacing }}</td>
            <td style="text-align: right">{{ item.ccFee | currency | currencySpacing }}</td>
            <td  style="text-align: right" *ngIf="!_reportService.selectedInvoiceDetails?.isOnlineOrder">{{ item.tipAmount | currency | currencySpacing }}</td>
            <td  style="text-align: right">{{ item.balance | currency | currencySpacing }}</td>
            <td>{{item.tenderTypeString}}</td>
            <td>{{item?.remarks}}</td>
            <!-- <td style="text-align: right">{{ item.discount | currency | currencySpacing }}</td>
            <td style="text-align: right">{{ item.linePrice | currency | currencySpacing }}</td> -->
        </tr>
    </ng-template>
</p-table>
</div>

<!-- Mobile card view -->
<div class="payment-cards">
    <div class="payment-card" *ngFor="let item of _reportService.selectedInvoiceDetails?.tenders">
        <div class="payment-detail">
            <div class="detail-label">Date</div>
            <div class="detail-value">{{ item.date | date: 'short' }}</div>
        </div>
        <div class="payment-detail">
            <div class="detail-label">Method</div>
            <div class="detail-value">{{ item.tenderTypeString }}</div>
        </div>
        <div class="payment-detail">
            <div class="detail-label">Amount</div>
            <div class="detail-value">{{ item.amount | currency | currencySpacing }}</div>
        </div>
        <div class="payment-detail">
            <div class="detail-label">Other Charges</div>
            <div class="detail-value">{{ item.ccFee | currency | currencySpacing }}</div>
        </div>
        <div class="payment-detail" *ngIf="!_reportService.selectedInvoiceDetails?.isOnlineOrder">
            <div class="detail-label">Tip</div>
            <div class="detail-value">{{ item.tipAmount | currency | currencySpacing }}</div>
        </div>
        <div class="payment-detail">
            <div class="detail-label">Balance</div>
            <div class="detail-value">{{ item.balance | currency | currencySpacing }}</div>
        </div>
        <div class="payment-detail payment-detail--full" *ngIf="item?.remarks">
            <div class="detail-label">Remarks</div>
            <div class="detail-value">{{ item.remarks }}</div>
        </div>
    </div>
    <div class="no-payments" *ngIf="!_reportService.selectedInvoiceDetails?.tenders?.length">
        No payments found.
    </div>
</div>
